var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2733 8.86455C10.8629 8.95323 10.4369 8.99993 10 8.99993C6.68629 8.99993 4 6.31364 4 2.99993C4 1.96248 4.2633 0.986526 4.72673 0.135254C2.02463 0.719145 0 3.12307 0 5.99988C0 9.31359 2.68629 11.9999 6 11.9999C8.27626 11.9999 10.2565 10.7323 11.2733 8.86455Z",
    fill: "#FFE187"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDarkMode);
export default __webpack_public_path__ + "static/media/icon-dark-mode.fca0b556f49a6c57509caa998aff40c2.svg";
export { ForwardRef as ReactComponent };